import { router } from "@inertiajs/react";
import { Box, Typography } from "@mui/material";
import ContactUsButton from "app/frontend/components/buttons/ContactUsButton";
import ContainedZoomButton from "app/frontend/components/buttons/ContainedZoomButton";
import { EIncentiveName, EProjectTypes } from "app/frontend/constants/enums";
import { ROUTES } from "app/frontend/constants/routes";
import { useProject } from "app/frontend/hooks/project/useProject";
import { useParamsProjectType } from "app/frontend/hooks/project/useParamsProjectType";
import { useProjectParams } from "app/frontend/hooks/usePropsParams";
import { useCallback, useEffect, useMemo } from "react";

interface IProps {
    header: string;
}

const NonMHDContinue: React.FC<IProps> = ({ header }) => {
    const project = useProject();
    const projectType = useParamsProjectType();
    const projectParams = useProjectParams();
    const plugCount = projectParams?.plugs?.[0]?.count ?? 0;

    const continueRoute = useMemo(() => {
        if (projectType === EProjectTypes.MICROMOBILITY) {
            return ROUTES.Projects.MICROMOBILITY;
        } else {
            return ROUTES.Projects[projectType as Exclude<keyof typeof EProjectTypes, "ALL">];
        }
    }, [projectType]);

    const continueData = useMemo(() => {
        const {
            address: _address,
            voucher_names: _voucher_names,
            plugs: _plugs,
            incentive_names,
            ...rest
        } = projectParams;

        return {
            project_type: projectType,
            project: {
                ...rest,
                preserve_amount: 1,
                incentive_names: incentive_names
                    ? incentive_names.concat(project.amount >= 25 ? [EIncentiveName.LARGE_PROJECT_BONUS] : [])
                    : [],
            },
        };
    }, [project.amount, projectParams, projectType]);

    useEffect(() => {
        router.prefetch(
            continueRoute,
            {
                method: "get",
                data: continueData,
            },
            { cacheFor: "1m" },
        );
    }, [continueRoute, continueData, projectType]);

    const onClick = useCallback(
        (e: React.MouseEvent<HTMLButtonElement>) => {
            e.preventDefault();
            e.stopPropagation();

            router.get(continueRoute, continueData);
        },
        [continueRoute, continueData],
    );

    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center",
                gap: 2,
                marginX: "auto",
                maxWidth: { xs: "100%", md: "80%", lg: "60%" },
            }}
        >
            <Typography>{header}</Typography>

            {Number(plugCount) < 2 && projectType === EProjectTypes.L2 ? (
                <ContactUsButton />
            ) : (
                <ContainedZoomButton onClick={onClick} sx={{ maxWidth: "100%" }}>
                    Continue to Incentive Calculator
                </ContainedZoomButton>
            )}
        </Box>
    );
};

export default NonMHDContinue;
